import {translations} from 'presentation/translations-new';
import {formatMasks} from 'presentation/utils/formatMasks';
import {validateCellPhone} from 'presentation/utils/validateCellPhone';

const {addYourCellphone, invalidCellphone} =
	translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

function phoneHandler(value: string) {
	return {
		hasValue: Boolean(value),
		invalidValue: !validateCellPhone(value),
		toString() {
			if (!this.hasValue) return addYourCellphone;
			if (this.invalidValue) return invalidCellphone;
			return formatMasks('phone', value);
		},
	};
}

export {phoneHandler};
